import { jsx as _jsx } from 'react/jsx-runtime.js';
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.js';
import { setActiveView } from '../../redux/core/wrapperContext/wrapperContextSlice.js';
import { FORM_TYPES } from '../../types/paramsConfig.js';
import { ConfirmationForm } from '../../redux/features/passwordless/Confirmation/index.js';
import { clearAlerts, passwordlessThunk, updateEmail, updateStepToDisplay, } from '../../redux/features/passwordless/passwordlessSlice.js';
import { accountIdentifierEmailSelector } from '../AccountIdentifier/accountIdentifierSlice.js';
import { validateEmail } from '../../helpers/validateEmail.js';
import { loginSourceSelector, redirectionUrlSelector, } from '../../redux/core/sourceData/sourceDataSlice.js';
import { useTrack } from '../../tracking/common/hooks/useTrack.js';
export const TwoStepPasswordlessConfirmation = () => {
    const email = useAppSelector(accountIdentifierEmailSelector);
    const redirectionUrl = useAppSelector(redirectionUrlSelector);
    const loginSource = useAppSelector(loginSourceSelector);
    const dispatch = useAppDispatch();
    const { trackBtnClick, trackModalComponentVisible } = useTrack('passwordLess');
    useEffect(() => {
        dispatch(updateEmail(email.value));
    }, [email.value]);
    trackModalComponentVisible();
    const sendAgainOnClick = () => {
        if (email && validateEmail(email.value)) {
            trackBtnClick({ uniqueName: 'resendEmail' });
            dispatch(passwordlessThunk({
                email: email.value,
                returnUrl: redirectionUrl,
                loginSource,
            }));
        }
    };
    const backButtonHandler = () => {
        trackBtnClick({ uniqueName: 'backLink' });
        dispatch(updateStepToDisplay('twoStepLogin'));
        // TODO: replace that with navigateTo
        dispatch(setActiveView(FORM_TYPES.TWO_STEP_LOGIN));
        dispatch(clearAlerts());
    };
    return (_jsx(ConfirmationForm, { buttonClick: sendAgainOnClick, backButtonHandler: backButtonHandler }));
};
//# sourceMappingURL=TwoStepPasswordlessConfirmation.js.map